import React from 'react';
import { FaBuilding, FaMapMarkerAlt, FaPuzzlePiece, FaHandshake, FaThumbsUp, FaClock } from 'react-icons/fa';
import '../Why/Why.css';

const Why = () => {
  const features = [
    {
      icon: <FaBuilding />,
      title: "60 YEARS OF LEGACY",
      description: "Over 6 decades of unprecedented experience in the construction field."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "PRIME LOCATIONS IN NCR",
      description: "Over 10 million sq. ft. area in prime locations of Delhi-NCR."
    },
    {
      icon: <FaPuzzlePiece />,
      title: "END-TO-END SOLUTIONS",
      description: "Professional end-to-end project management and delivery practices."
    },
    {
      icon: <FaHandshake />,
      title: "TRUSTED BRAND",
      description: "Delivering authentic, customer-focused, experiential innovative structures with transparency and synergy."
    },
    {
      icon: <FaThumbsUp />,
      title: "QUALITY CONTROL SYSTEM",
      description: "In-house quality control systems and processes with structured manuals to deliver excellence in quality."
    },
    {
      icon: <FaClock />,
      title: "TIMELY DELIVERY",
      description: "Developing visionary buildings with commitment and assured on-time delivery."
    },
  ];

  return (
    <section className="why-section">
      <h2 className="why-title">Why <span>Trehan Iris</span></h2>
      <div className="why-features">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Why;
